import styled from 'styled-components'

const ProductStockLimitContainerUi = styled.div`
  display: flex;
  gap: 5px;
  color: #142d63;
`
export default ProductStockLimitContainerUi
